import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSubscription } from '@/contexts/SubscriptionContext';

// A tax advisor (role tax_advisor) only has the read-only Steuerberater portal.
// Keep them inside it: redirect away from any non-portal, non-auth route.
const ALLOWED = ['/steuerberater', '/login', '/einladung', '/accept-invite', '/logout', '/passwort', '/reset-password'];

export const TaxAdvisorRedirect = () => {
  const { role, loading } = useSubscription();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading || role !== 'tax_advisor') return;
    if (ALLOWED.some((p) => location.pathname.startsWith(p))) return;
    navigate('/steuerberater', { replace: true });
  }, [role, loading, location.pathname, navigate]);

  return null;
};
